export default __webpack_public_path__ + "static/media/robot-gladiators.4f8aaa16.png";